const doc = [({"da":({"js":({"admin":({"reimbursement_attachments":({"expandable_content":({"description":({"number_of_characters":"Antal tegn"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;